import { MARKETS_DESCRIPTION } from "application/constants/app-constants";
import getCountry from "./getCountry";
import { find, keys } from "ramda";

export default function getMarketDescription() {
  const country = getCountry();
  const countryKeys = keys(MARKETS_DESCRIPTION);
  const region = find((k) => k === country, countryKeys);
  if (region) return MARKETS_DESCRIPTION[region];

  return MARKETS_DESCRIPTION["gb"];
}
